import PartPrice from '@/models/PartPrice/PartPrice';

export default class PartPriceFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.partClassification = '';
		this.startDateFrom = '';
		this.startDateTo = '';
		this.endDateFrom = '';
		this.endDateTo = '';
		this.vendorIdId  = '';
		this.vendorIdCode = '';
		this.priceProcess = '';
		this.priceProcessFrom = '';
		this.priceProcessTo = '';
		this.priceProduct = '';
		this.priceProductFrom = '';
		this.priceProductTo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			partClassification : '0',
			startDateFrom : '0',
			startDateTo : '0',
			endDateFrom : '0',
			endDateTo : '0',
			vendorIdId : '0',
			vendorIdCode : '0',
			priceProcess : '0',
			priceProduct : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}